// This file should have no expensive imports except dynamic imports. It should only check IF we should load the reviews stars or not.
import { WidgetAutocheck } from "@redotech/redo-model/widget";

export const REVIEW_STARS_SELECTOR = "div.redo-review-stars";

export const isReviewsEnabled = (autocheck: WidgetAutocheck) => {
  return autocheck.reviews.enabled;
};

export const initializeIfReviewsElementsFound = async (
  autocheck: WidgetAutocheck,
) => {
  const elements = document.querySelectorAll(REVIEW_STARS_SELECTOR);

  for (const element of elements) {
    const { initializeStarContainer } = await import("./review-stars");
    initializeStarContainer(element, autocheck);
  }

  const observer = new MutationObserver(async (mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "childList") {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const element = node as Element;

            if (element.matches(REVIEW_STARS_SELECTOR)) {
              const { initializeStarContainer } = await import(
                "./review-stars"
              );
              initializeStarContainer(element, autocheck);
            }

            const childStarElements = element.querySelectorAll(
              REVIEW_STARS_SELECTOR,
            );
            for (const childElement of childStarElements) {
              const { initializeStarContainer } = await import(
                "./review-stars"
              );
              initializeStarContainer(childElement, autocheck);
            }
          }
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
};
